import { createSlice } from "@reduxjs/toolkit";

export const siteDataSlice = createSlice({
  name: "site_data",
  initialState: {
    side_nav: false,
    show: false,
    message: "",
    severity: "error", // Add severity field
    loadingScreen: false,
  },
  reducers: {
    resetSnackBar: (state) => {
      state.show = false;
      state.message = "";
      state.severity = "error";
    },
    setSnackBar: (state, action) => {
      state.show = true;
      // Handle both string and object payloads
      if (typeof action.payload === "string") {
        state.message = action.payload;
        state.severity = "error"; // default
      } else {
        state.message = action.payload.message;
        state.severity = action.payload.severity || "info";
      }
    },
    // New action for custom severity
    setSnackBarWithSeverity: (state, action) => {
      state.show = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity;
    },
    showSideNav: (state) => {
      state.side_nav = !state.side_nav;
    },
    showLoadingScreen: (state, action) => {
      state.loadingScreen = action.payload;
    },
  },
});

// Action creators
export const {
  showLoadingScreen,
  resetSnackBar,
  setSnackBar,
  setSnackBarWithSeverity,
  showSideNav,
} = siteDataSlice.actions;

export const selectSiteData = (state) => state.site_data;
export default siteDataSlice.reducer;
